import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@frontend/shadcn/components/ui/accordion';
import { P } from '@frontend/shadcn/components/typography/p';
import { Checkbox } from '@frontend/shadcn/components/ui/checkbox';
import { FormAsyncAction } from '@frontend/applications/AffiliatesApp/components/OfferForm/types';

interface IProps {
    handleFormAsyncActions: (value: FormAsyncAction) => void;
    showPayoutsOnCreatorPortal: boolean;
    hideOfferFromCreators: boolean;
}

export function RefreshCreatorSettings({ handleFormAsyncActions, showPayoutsOnCreatorPortal, hideOfferFromCreators }: IProps): JSX.Element {
    const handleCheckChange = (value: boolean) => {
        handleFormAsyncActions({ action: 'UpdateField', payload: { key: 'showPayoutsOnCreatorPortal', value } });
      };

      const handleHideOfferFromCreatorsChange = (value: boolean) => {
        handleFormAsyncActions({ action: 'UpdateField', payload: { key: 'hideOfferFromCreators', value } });
      };

  return (
    <>
      <Accordion type="single" collapsible className="w-full">
        <AccordionItem value="creator-settings">
          <AccordionTrigger className="hover:no-underline p-0 mt-2">
            <div className="flex flex-col gap-1">
              <P className="text-grey-6" fontWeight="font-medium">
                Creator Settings
              </P>
            </div>
          </AccordionTrigger>
          <AccordionContent>
            <div className="flex items-center gap-2 mb-2">
              <Checkbox
                id="hide-payouts-on-creator-portal"
                checked={showPayoutsOnCreatorPortal}
                onCheckedChange={(checked) => handleCheckChange(checked === true)}
              />
              <label htmlFor="hide-payouts-on-creator-portal" className="text-sm font-medium text-primary">
                Show payout details to creators
              </label>
            </div>
            {/* Checkbox for Hide offer from creators */}
            <div className="flex items-center gap-2 mb-2">
              <Checkbox
                id="hide-offer-from-creators"
                checked={hideOfferFromCreators}
                onCheckedChange={(checked) => handleHideOfferFromCreatorsChange(checked === true)}
              />
              <label htmlFor="hide-offer-from-creators" className="text-sm font-medium text-primary">
                Hide offer from creators
              </label>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </>
  );
}
